module.exports = __webpack_public_path__ + "img/full0-min.2741714e.png";